import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';

export default {
  data() {
    return {
      responseCodes: [401, 422]
    }
  },
  methods: {
    error(error) {
      switch(error.response.status) {
        case 401:
          swal.fire({
            title: `Error`,
            text: error.response.data,
            showConfirmButton: false,
            timer: 3000,
            icon: 'error'
          }).then(result => {
              this.$router.go();
          });
          break;
        default:
          this.$notify({
            type: 'danger',
            message: error.response.data.message ? error.response.data.message : error.response.data,
            icon: 'fas fa-circle-exclamation'
          });
          break;
      }
    }
  }
}